import React, { useEffect, useState } from 'react';
import BuildingHeader from './BuildingHeader';
import UnitCard from './UnitCard';
import BuildingEdit from './BuildingEdit';
import CreateOffer from './CreateOffer';
import UnitApplications from './UnitApplications';
import UnitDetails from './BLDGUnitDetails.jsx';
import styles from '../../styles/Building MGMT/BuildingManagement.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const BuildingManagement = ({ buildingId }) => {
  const [building, setBuilding] = useState({ units: [] });
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [activeView, setActiveView] = useState('Building');
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(false);


  useEffect(() => {
    const landlordUserId = localStorage.getItem("landlordUserId");
    setLoading(true);

    fetch(`${API_BASE_URL}/properties/landlord/${landlordUserId}/buildings/${buildingId}/units`, {
      credentials: "include"
    })
      .then(res => res.json())
      .then(units => {
        setBuilding(prev => ({
          ...prev,
          id: buildingId,
          units,
        }));
        setLoading(false);
      })
      .catch(err => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
  }, [buildingId, refreshFlag]);

  if (loading) return <div className={styles.loading}>Loading...</div>;
  if (!building || !building.units.length) return <div className={styles.notFound}>Building not found or no units available.</div>;

  const activeUnits = building.units.filter(unit => unit.activeOnMILO && unit.rent);
  const otherUnits = building.units.filter(unit => !unit.activeOnMILO || !unit.rent);

  const handleCreateOffer = (unit) => {
    setSelectedUnit(unit);
    setActiveView('CreateOffer');
  };

  const handleManageApplications = (unit) => {
    setSelectedUnit(unit);
    setActiveView('ManageApplications');
  };

  const handleSaveOffer = (offerDetails) => {
    console.log('Offer created:', offerDetails);
	setRefreshFlag(prev => !prev);
    setActiveView('Building');
  };
  
  const handleViewDetails = (unit) => {
    setSelectedUnit(unit);
    setActiveView('UnitDetails');
  };

  return (
    <div className={styles.container}>
      <BuildingHeader building={building} onEdit={() => setIsEditing(true)} />

      {isEditing ? (
        <BuildingEdit
          initialBuilding={building}
          onSave={(updatedBuilding) => {
            setBuilding(updatedBuilding);
            setIsEditing(false);
          }}
          onCancel={() => setIsEditing(false)}
        />
      ) : activeView === 'CreateOffer' && selectedUnit ? (
        <CreateOffer 
          unitId={selectedUnit.id} 
          onCancel={() => setActiveView('Building')} 
          onSave={handleSaveOffer}
          handleBack={() => setActiveView('Building')} 
        />
      ) : activeView === 'ManageApplications' && selectedUnit ? (
        <UnitApplications unitId={selectedUnit.id} handleBack={() => setActiveView('Building')} />
      ) : activeView === 'UnitDetails' && selectedUnit ? (
        <UnitDetails unit={selectedUnit} unitId={selectedUnit.id} handleBack={() => setActiveView('Building')} />
      ) : (
        <>
          <div className={styles.metrics}>
            <div className={styles.metric}>
              <span>{building.units.length}</span>
              <p>Total Units</p>
            </div>
            <div className={styles.metric}>
              <span>{building.units.filter(u => u.isOccupied).length}</span>
              <p>Occupied Units</p>
            </div>
            <div className={styles.metric}>
              <span>{activeUnits.length}</span>
              <p>Units on MILO</p>
            </div>
          </div>

          <div className={styles.unitList}>
            <h3>🏡 Units Currently Active on MILO</h3>
            <div className={styles.unitsGrid}>
              {activeUnits.map(unit => (
                <UnitCard 
                  key={unit.id} 
                  unit={unit}
                  onManageApplications={() => handleManageApplications(unit)} 
                  onCreateOffer={() => handleCreateOffer(unit)}
                  onViewDetails={() => handleViewDetails(unit)}
                />
              ))}
            </div>
          </div>

          <div className={styles.unitList}>
            <h3>📦 All Other Units</h3>
            <div className={styles.unitsGrid}>
              {otherUnits.map(unit => (
                <UnitCard 
                  key={unit.id} 
                  unit={unit}
                  onCreateOffer={() => handleCreateOffer(unit)}
                  onViewDetails={() => handleViewDetails(unit)}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BuildingManagement;
